/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPrivacyRequest} from '../api'

export const useMutationCreatePrivacyRequest = createReactQueryMutationHook('createPrivacyRequest', createPrivacyRequest)
